import { groupBy, uniq } from 'lodash';

import { dateFormatForAPI, formatDate } from '../utils/date';

const getBookingItemParam = ({
  startTime,
  endTime,
  space: { id: spaceId } = {} as { id?: number },
}: {
  startTime: string;
  endTime: string;
  space?: { id?: number };
}) => ({
  date: formatDate(startTime, dateFormatForAPI),
  startTime: formatDate(startTime, 'HH:mm'),
  endTime: formatDate(endTime, 'HH:mm'),
  spaceId,
});

interface AvailabilityBookingItem {
  startTime: string;
  endTime: string;
  space: { id: number };
}

interface AvailabilityBooking {
  id: number;
  startTime: string;
  clientService: { id: number };
  recurrenceRules?: unknown;
  bookingItems: AvailabilityBookingItem[];
}

const bookingToAvailabilityPayload = (booking: AvailabilityBooking) => {
  const groupedBookingItems = groupBy(
    booking.bookingItems,
    ({ startTime, endTime }: { startTime: string; endTime: string }) =>
      `${formatDate(startTime, 'HH:mm')}${formatDate(endTime, 'HH:mm')}`
  );
  const bookingSlots = Object.keys(groupedBookingItems).map(i => {
    const firstBookingItem = groupedBookingItems[i][0];

    return {
      startTime: formatDate(firstBookingItem.startTime, 'HH:mm'),
      endTime: formatDate(firstBookingItem.endTime, 'HH:mm'),
    };
  });
  const spaceIds = uniq(
    booking.bookingItems.map(
      (bookingItem: { space: { id: number } }) => bookingItem.space.id
    )
  );

  return {
    date: formatDate(booking.startTime, dateFormatForAPI),
    spaceIds,
    clientServiceId: booking.clientService.id,
    slots: bookingSlots,
    ...(booking.recurrenceRules ? { recurrence: booking.recurrenceRules } : {}),
    ...(booking.bookingItems
      ? { bookingItems: booking.bookingItems.map(getBookingItemParam) }
      : {}),
    excludedBookingIds: [booking.id],
  };
};

export default bookingToAvailabilityPayload;
